// extracted by mini-css-extract-plugin
export default {"wrapper":"fVmj0A","active":"YT0WNU","overlay":"Q14S8E","modal":"xVHZQF","head":"vumMVe","closeButton":"Y0HbMU"};